import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { i18n } from '@/utils/i18n';

// Schemas
const contactNpoSchema = Yup.object().shape({
  email: Yup.string().email(i18n.t('mix.valid_email')).required(i18n.t('mix.required_email')),
  reason: Yup.string().required(i18n.t('mix.reason_required'))
});

// Types
export type ContactNpoData = Yup.InferType<typeof contactNpoSchema>;

// Resolvers
export const contactNpoResolver = yupResolver(contactNpoSchema);
